<div id="wrapper">
    <!-- topbar -->
    <app-topbar (mobileMenuButtonClicked)="onToggleMobileMenu()"
                layoutType="vertical"></app-topbar>
    <!-- left side bar-->
    <app-left-sidebar [includeUserProfile]="showSidebarUserInfo">
    </app-left-sidebar>

    <div class="content-page">
        <div class="subscription-toolbar" *ngIf="company && company.trial_ends_at && !subscriptionService.subscription && showSubBanner">
            <i class="mdi mdi-calendar-clock mr-3"></i>
            <span *ngIf="!trialEnded">Do końca okresu próbnego pozostało <strong class="ml-1 mr-1"> {{daysToTrialEnd}}</strong> dni</span>
            <span *ngIf="trialEnded">Twój okres próbny zakończył się</span>
            <button routerLink="/apps/global/billings/subscription" class="btn btn-sm btn-danger ml-3">Wybierz abonament</button>
        </div>
        <div class="content">
            <!-- content -->
            <div class="container-fluid" *ngIf="reRender">
                <router-outlet></router-outlet>
            </div>
        </div>
        <!-- footer -->
        <app-footer></app-footer>
    </div>
</div>
